import React from 'react';
import { Sparkles } from 'lucide-react';
interface AIButtonProps {
  onClick: () => void;
}
const AIButton: React.FC<AIButtonProps> = ({
  onClick
}) => {
  return <button onClick={onClick} className="fixed bottom-6 right-6 z-30 flex items-center justify-center h-14 w-14 rounded-full bg-purple-600 text-white shadow-lg hover:bg-purple-700 transition-all duration-200 hover:scale-105 group" aria-label="AI Suggestions" data-id="element-123">
      <Sparkles className="h-6 w-6" data-id="element-124" />
      <span className="absolute opacity-0 group-hover:opacity-100 right-full mr-2 px-3 py-1 bg-white text-purple-600 text-sm font-medium rounded-md shadow-md whitespace-nowrap transition-opacity duration-200" data-id="element-125">
        AI Suggestions
      </span>
    </button>;
};
export default AIButton;